module.exports = __webpack_public_path__ + "img/baggage-plus.2b5b873d.svg";